export const getYearMonthFromDate = (date) => {
    return (
        date.getFullYear() +
        '-' +
        String(Number(date.getMonth() + 1)).padStart(2, '0')
    );
};